"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var component = function (props) { return (React.createElement("div", { className: 'sok-distribution-wizard-step3' },
    React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.wizard.isSaving === 'STANDBY' ||
            props.wizard.isSaving === 'SAVING', success: props.wizard.isSaving === 'SAVED' }),
    React.createElement("p", null,
        (props.wizard.isSaving === 'STANDBY' ||
            props.wizard.isSaving === 'SAVING') &&
            (0, translation_1.getLocalization)('userfront/distribution/step3/generating'),
        props.wizard.isSaving === 'SAVED' &&
            (0, translation_1.getLocalization)('userfront/distribution/step3/successfully'),
        props.wizard.isSaving === 'FAILED' &&
            (0, translation_1.getLocalization)('userfront/distribution/step3/error')),
    props.wizard.isSaving === 'FAILED' && (React.createElement("p", { className: 'error-button', onClick: props.tryAgain(props) }, (0, translation_1.getLocalization)('userfront/distributionwizard/step3/tryAgain'))),
    props.wizard.isSaving === 'SAVED' && (React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distributionwizard/step3/thankyou'))))); };
exports.default = component;
